import { TFunction } from "i18next";
import { Gender, QuestionType } from "src/graphql/generated/graphql";
import { DeliveryState } from "src/hooks/campaigns";
import { ClientLocale } from "src/types";

const SupportedCountryCode = {
    cz: "cz",
    sk: "sk",
    de: "de",
    pl: "pl",
    hu: "hu",
    at: "at",
    ch: "ch",
    it: "it",
    es: "es",
    gb: "gb",
    ro: "ro",
    bg: "bg",
} as const;

export type SupportedCountryCode = keyof typeof SupportedCountryCode;

export const checkCountryCode = (countryCode: string): countryCode is SupportedCountryCode => {
    return !!SupportedCountryCode[countryCode as SupportedCountryCode];
};

export const resolveCountryCode = (locale: string) => {
    switch (locale) {
        case "en":
            return "gb";
        case "en-GB":
            return "gb";
        case "en-US":
            return "gb";
        case "cs":
        case "cs-CZ":
            return "cz";
        case "sk":
            return "sk";
        case "de":
            return "de";
        case "pl":
            return "pl";
        case "hu":
            return "hu";
    }

    return null;
};

export const resolveDatesLocale = (locale: string) => {
    switch (locale) {
        case "en":
            return "en-gb";
        case "en-GB":
            return "en-gb";
        case "en-US":
            return "en-gb";
        case "cs":
            return "cs";
    }

    return null;
};

export const checkGender = (gender: string): gender is Gender => {
    return !!Gender[gender as Gender];
};

export const checkDeliveryType = (deliveryType: string): deliveryType is DeliveryState => {
    return !!DeliveryState[deliveryType as DeliveryState];
};

export const unsafeTranslate = (key: string, t: TFunction): string | undefined => {
    const result = (t as unknown as (key: string) => string)(key);
    return result === key ? undefined : result;
};

const SupportedCurrency = {
    czk: "czk",
    bgn: "bgn",
    eur: "eur",
    huf: "huf",
    pln: "pln",
    ron: "ron",
    usd: "usd",
} as const;

export type SupportedCurrency = keyof typeof SupportedCurrency;

export const checkCurrency = (currency: string): currency is SupportedCurrency => {
    return !!SupportedCurrency[currency as SupportedCurrency];
};

export const SupportedLocale = {
    ...ClientLocale,
    sk: "sk",
    de: "de",
    hu: "hu",
    pl: "pl",
    fr: "fr",
} as const;

export type SupportedLocale = keyof typeof SupportedLocale;

export const checkClientLocale = (locale: string): locale is ClientLocale => {
    return !!ClientLocale[locale as ClientLocale];
};

export const checkSupportedLocale = (locale: string): locale is SupportedLocale => {
    return !!SupportedLocale[locale as SupportedLocale];
};

export const checkQuestionType = (type: string): type is QuestionType => {
    return !!QuestionType[type as QuestionType];
};

export const ExportJobState = {
    started: "started",
    finished: "finished",
    error: "error",
} as const;

export type ExportJobState = keyof typeof ExportJobState;

export const checkExportJobState = (state: string): state is ExportJobState => {
    return !!ExportJobState[state as ExportJobState];
};
